/**
 * Public Motzu Shopify app install.
 *
 * Flip to `true` when the Motzu app listing is available for merchants again.
 * While `false`, Connect Shopify defaults to "Your own custom app", marks that
 * option Recommended, and greys out "Motzu app" with a coming-soon note.
 * The Motzu-app OAuth path stays in IntegrationInstallWizard; this only
 * closes the entry so a store cannot be sent to a dead Shopify install link.
 */
export const SHOPIFY_PUBLIC_APP_INSTALL_ENABLED = false;

export type ShopifyConnectMethod = 'app' | 'custom';

/** Method the Store step should start on. */
export function resolveShopifyConnectMethod(
  launchMethod?: ShopifyConnectMethod,
  publicAppEnabled: boolean = SHOPIFY_PUBLIC_APP_INSTALL_ENABLED,
): ShopifyConnectMethod {
  if (!publicAppEnabled) return 'custom';
  return launchMethod ?? 'app';
}

/** Which radio carries the Recommended badge. */
export function shopifyConnectRecommendedMethod(
  existingCustomApp: boolean,
  publicAppEnabled: boolean = SHOPIFY_PUBLIC_APP_INSTALL_ENABLED,
): ShopifyConnectMethod {
  if (existingCustomApp) return 'custom';
  return publicAppEnabled ? 'app' : 'custom';
}
